var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutGame',[_c('div',{staticClass:"main",style:(("background-color: " + _vm.backgroundColor))},[_c('canvas',{attrs:{"id":"my-coins","height":"720","width":"960"}}),_c('Home'),_c('Game'),_c('GameOver'),_c('Settings')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }